import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getListOfBooksByAgeFromServer, requestToGetBooksByIdFromServer, requestToCreateNewBook, requestToUpdateBook } from "../../controller/addBook/crudBookController";
import errorHandler from "../../utils/errorHandler";
import { addAgeGroup, addBookAuthor, addBookCoverImage, addBookTitle, addCurrentBookIdToLocalStorage, addEducationLevel, clearCurrentParagraph, clearFormFromLocalStorage, getAgeGroupOpt, getBookAuthor, getBookCoverImage, getBookTitle, getCurrentPargraph, getEducationLvl, getListOfParagraph, storeCurrentParagraph, storeListOfParagraph } from "../../utils/localStorage";

const initialState = {
    isLoading:false,
    isSuccess:true,
    bookList:[],
    totalBook:0,
    ageGroupOpt:getAgeGroupOpt(),
    educationLevel:getEducationLvl(getAgeGroupOpt().name),
    title:getBookTitle(),
    author:getBookAuthor(),
    paragraph:getCurrentPargraph(),
    paragraphs:getListOfParagraph(),
    image:'',
    level:''
};


const addBookSlice = createSlice({
    name:'addBooks',
    initialState,
    reducers:{
        ageGroupSelected:(state, {payload}) => {
            const { name, isSelected } = payload;
            let obj = { name, isSelected };
            addAgeGroup(obj);
            state.ageGroupOpt = obj;
        },
        gradeSelected: (state, {payload}) => {
            const { ageGroup, grade } = payload;
            state.educationLevel = grade;
            addEducationLevel(ageGroup, grade);
            
        },
        onBookLevelSelected: (state, {payload}) => {
            state.level = payload;
        },
        onTitleEntered:(state, {payload}) => {
            const title = payload;
            state.title = title;
            addBookTitle(title);
        },
        onAuthorEntered:(state, {payload}) => {
            const author = payload;
            state.author = author;
            addBookAuthor(author);
        },
        onImageSelected: (state, {payload}) => {
            state.image = payload;
        },
        onParagraphChanged:(state, {payload}) => {
            const paragraph = payload;
            state.paragraph = paragraph;
            storeCurrentParagraph(paragraph);
        },
        onSaveParagraphsTriggered:(state, {payload}) => {
            const paragraphObj = payload;
            let list = state.paragraphs;
            list.push(paragraphObj);
            storeListOfParagraph(list);
            state.paragraph = "";
            clearCurrentParagraph();
        },
        onRequestToClearForm:(state) => {
            clearState(state);
        },
        onBookSelected: (state, {payload}) => {
            const {_id, book, grade} = payload;
            state.educationLevel = grade;
            state.title = book.title;
            state.author = book.author;
            state.paragraphs = book.paragraphs;
            let paragraph = book.paragraphs.findLast(() => true);
            state.paragraph = paragraph.paragraph;
            addCurrentBookIdToLocalStorage(_id);
            addEducationLevel(state.ageGroupOpt.name, grade);
            addBookTitle(book.title);
            addBookAuthor(book.author);
            storeListOfParagraph(book.paragraphs);
        }
     },
     extraReducers:{
        // ***REQUEST TO CREATE/UPDATE***
        [requestToCreateNewBook.pending]:(state) => {
            state.isLoading = true;
        },
        [requestToCreateNewBook.fulfilled]:(state, {payload}) => {
            state.isLoading = false;
            toast.success('Submitted Successfully!');
            clearState(state);
        },
        [requestToCreateNewBook.rejected]:(state, {payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        },

        [requestToUpdateBook.pending]:(state) => {
            state.isLoading = true;
        },
        [requestToUpdateBook.fulfilled]:(state, {payload}) => {
            state.isLoading = false;
            console.log("Updated result:" + payload);
            toast.success('Submitted Successfully!');
        },
        [requestToUpdateBook.rejected]:(state, {payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        },
        // **** END ****


        // ***REQUEST TO GET BOOKS FROM SERVER***
        [getListOfBooksByAgeFromServer.pending]:(state) => {
            state.isLoading = true;
        },
        [getListOfBooksByAgeFromServer.fulfilled]:(state, {payload}) => {
            state.isLoading = false;
            const {success, data, count } = payload;
            state.isSuccess = success;
            state.bookList = data;
            state.totalBook = count;
        },
        [getListOfBooksByAgeFromServer.rejected]:(state,{payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        },
        // **** END ****


        // ***REQUEST TO GET BOOK BY ID***
        [requestToGetBooksByIdFromServer.pending]:(state) => {
            state.isLoading = true;
        },
        [requestToGetBooksByIdFromServer.fulfilled]:(state, {payload}) => {
            state.isLoading = false;
        },
        [requestToGetBooksByIdFromServer.rejected]:(state, {payload}) => {
            state.isLoading = false;
            errorHandler(payload);
        }
        // ***END***
     }
});
const clearState = (state) => {
    state.ageGroupOpt = {name:'',isSelected:false};
            state.educationLevel = '';
            state.title = '';
            state.author = '';
            state.image = '';
            state.paragraph = '';
            state.paragraphs = [];
            clearFormFromLocalStorage();
};
export const { 
    ageGroupSelected, 
    gradeSelected, 
    onTitleEntered, 
    onAuthorEntered, 
    onSaveParagraphsTriggered, 
    onParagraphChanged, 
    onRequestToClearForm, 
    onBookSelected, 
    onGradeSelected, 
    onImageSelected,
    onBookLevelSelected
} = addBookSlice.actions;
export default addBookSlice.reducer;